import axios from '@api'

export default {
    getMaterialType() {
      return axios.get(`api/management/materialtype`);
    },
    deleteMaterialType(materialTypeId) {
      return axios.put(`api/management/materialtype/delete/${materialTypeId}`);
    },
    saveMaterialType(json) {
      return axios.post(`api/management/materialtype/save`, json);
    }
}